export default __webpack_public_path__ + "static/media/T740_CoC.0392d3f3.pdf";